import { GenerarFicheroModelo347CommandProps } from "api/Commands/GenerarFicheroModelo347Command"
import { DeclaradoDeclaracionModelo347DtoProps } from "api/DTOs/DeclaradoDeclaracionModelo347Dto"
import { InmuebleDeclaracionModelo347DtoProps } from "api/DTOs/InmuebleDeclaracionModelo347Dto"

export interface DeclaradosFormModel {
  nif?: string
  nifOperadorComunitario?: string | null
  nifRepresentanteLegal?: string | null
  denominacionDeclarado?: string
  provincia?: string
  codigoPais?: string
  clave?: string
  esOperacionSeguro?: boolean
  esOperacionNegocio?: boolean
  esOperacionIvaCaja?: boolean
  esOperacionIsp?: boolean
  esOperacionAduanero?: boolean
  importePercibidoMetalico?: number
  ejercicio?: number
  importeAnual?: number
  importeAnualPercibidoTransmisionesInmueblesSujetasIva?: number
  importeAnualOperacionesDevengadasCriterioCajaIva?: number
  importePrimerTrimestre?: number
  importePercibidoTransmisionesInmueblesSujetasIvaPrimerTrimestre?: number
  importeSegundoTrimestre?: number
  importePercibidoTransmisionesInmueblesSujetasIvaSegundoTrimestre?: number
  importeTercerTrimestre?: number
  importePercibidoTransmisionesInmueblesSujetasIvaTercerTrimestre?: number
  importeCuartoTrimestre?: number
  importePercibidoTransmisionesInmueblesSujetasIvaCuartoTrimestre?: number
}
export interface Modelo347FormModel {
  "01"?: number
  "02"?: number
  "03"?: number
  "04"?: number
  ejercicio?: number
  apellidosYNombrePersona?: string | null
  declaracionComplementaria?: boolean | null
  declaracionSustitutiva?: boolean | null
  nifDeclarante?: string | null
  nifRepresentanteLegal?: string | null
  nombreDeclarante?: string | null
  numeroIdentificativoDeclaracionAnterior?: number | null
  telefonoPersona?: string | null
  declarados?: DeclaradosFormModel[] | null
  inmuebles?: InmuebleDeclaracionModelo347DtoProps[] | null
}

export const postDeclaracionModelo347Adapter = (
  formData: Modelo347FormModel
): GenerarFicheroModelo347CommandProps => {
  return {
    declaracion: {
      declarados: formData?.declarados?.map(
        (
          declarado: DeclaradosFormModel
        ): DeclaradoDeclaracionModelo347DtoProps => ({
          arrendamientoLocalNegocio: declarado?.esOperacionNegocio,
          claveOperacion: declarado?.clave,
          codigoPais: declarado?.codigoPais,
          codigoProvincia: declarado?.provincia,
          denominacionDeclarado: declarado?.denominacionDeclarado,
          ejercicio2: declarado?.ejercicio,
          importeAnualOperaciones: declarado?.importeAnual,
          importeAnualOperacionesDevengadasCriterioCajaIva:
            declarado?.importeAnualOperacionesDevengadasCriterioCajaIva,
          importeAnualPercibidoTransmisionesInmueblesSujetasIva:
            declarado?.importeAnualPercibidoTransmisionesInmueblesSujetasIva,
          importeOperacionesCuartoTrimestre: declarado?.importeCuartoTrimestre,
          importeOperacionesPrimerTrimestre: declarado?.importePrimerTrimestre,
          importeOperacionesSegundoTrimestre:
            declarado?.importeSegundoTrimestre,
          importeOperacionesTercerTrimestre: declarado?.importeTercerTrimestre,
          importePercibidoMetalico: declarado?.importePercibidoMetalico,
          importePercibidoTransmisionesInmueblesSujetasIvaCuartoTrimestre:
            declarado?.importePercibidoTransmisionesInmueblesSujetasIvaCuartoTrimestre,
          importePercibidoTransmisionesInmueblesSujetasIvaPrimerTrimestre:
            declarado?.importePercibidoTransmisionesInmueblesSujetasIvaPrimerTrimestre,
          importePercibidoTransmisionesInmueblesSujetasIvaSegundoTrimestre:
            declarado?.importePercibidoTransmisionesInmueblesSujetasIvaSegundoTrimestre,
          importePercibidoTransmisionesInmueblesSujetasIvaTercerTrimestre:
            declarado?.importePercibidoTransmisionesInmueblesSujetasIvaTercerTrimestre,
          nifDeclarado: declarado?.nif,
          nifOperadorComunitario: declarado?.nifOperadorComunitario,
          nifRepresentanteLegal: declarado?.nifRepresentanteLegal,
          operacionSeguro: declarado?.esOperacionSeguro,
          opIsp: declarado?.esOperacionIsp,
          opIvaCaja: declarado?.esOperacionIvaCaja,
          opRegDepDistintoAduanero: declarado?.esOperacionAduanero,
        })
      ),
      declarante: {
        apellidosYNombrePersona: formData?.apellidosYNombrePersona,
        declaracionComplementaria: formData?.declaracionComplementaria,
        declaracionSustitutiva: formData?.declaracionSustitutiva,
        importeTotalAnualOperacciones: formData?.["02"],
        importeTotalOperacionesArrendamientoLocalesNegocio: formData?.["04"],
        nifDeclarante: formData?.nifDeclarante ? formData?.nifDeclarante : null,
        nifRepresentanteLegal: formData?.nifRepresentanteLegal
          ? formData?.nifRepresentanteLegal
          : null,
        nombreDeclarante: formData?.nombreDeclarante
          ? formData?.nombreDeclarante
          : null,
        numeroIdentificativoDeclaracionAnterior:
          formData?.numeroIdentificativoDeclaracionAnterior,
        numeroTotalInmuebles: formData?.["03"],
        numeroTotalPersonasYEntidades: formData?.["01"],
        telefonoPersona: formData?.telefonoPersona,
      },
      ejercicio: formData?.ejercicio,
      inmuebles: formData?.inmuebles?.map(
        (inmueble: InmuebleDeclaracionModelo347DtoProps) => ({
          bloque: inmueble?.bloque,
          calificadorNumero: inmueble?.calificadorNumero,
          codigoMunicipio: inmueble?.codigoMunicipio,
          codigoPostal: inmueble?.codigoPostal,
          codigoProvincia: inmueble?.codigoProvincia,
          complemento: inmueble?.complemento,
          denominacionArrendatario: inmueble?.denominacionArrendatario,
          escalera: inmueble?.escalera,
          importeOperacion: inmueble?.importeOperacion,
          localidadPoblacion: inmueble?.localidadPoblacion,
          municipio: inmueble?.municipio,
          nifArrendatario: inmueble?.nifArrendatario,
          nifRepresentanteLegal: inmueble?.nifRepresentanteLegal,
          nombreViaPublica: inmueble?.nombreViaPublica,
          numeroCasa: inmueble?.numeroCasa,
          plantaPiso: inmueble?.plantaPiso,
          portal: inmueble?.portal,
          puerta: inmueble?.puerta,
          referenciaCatastral: inmueble?.referenciaCatastral,
          situacionInmueble: inmueble?.situacionInmueble,
          tipoNumeracion: inmueble?.tipoNumeracion,
          tipoVia: inmueble?.tipoVia,
        })
      ),
    },
  }
}
